<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">Abbruch</ion-button>
    </ion-buttons>

    <ion-title *ngIf="isNewEvent">Neues Ereignis</ion-title>
    <ion-title *ngIf="!isNewEvent">Ereignis bearbeiten</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="confirm()"
        *ngIf="
          isNewEvent &&
          this.selectedEvent.endDate > this.selectedEvent.startDate
        "
        >Erstellen</ion-button
      >
      <ion-button
        (click)="confirm()"
        *ngIf="
          !isNewEvent &&
          this.selectedEvent.endDate > this.selectedEvent.startDate
        "
        >Aktualisieren</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-list>
    <ion-item>
      <ion-input
        labelPlacement="floating"
        [(ngModel)]="selectedEvent.name"
        mode="md"
      >
        <div slot="label">Name</div>
      </ion-input>
    </ion-item>
    <!--ion-item>
            <ion-toggle [(ngModel)]="fullDayEvent" (ionChange)="fullDayToggle()"
              >Ganztägig</ion-toggle
            >
          </ion-item-->
    <ion-item>
      <ion-label>Start</ion-label>

      <lib-date-time-picker
        slot="end"
        [inputDateZulu]="isNewEvent ? null : this.selectedEvent.startDate"
        (selectedDateChanged)="newEventStartDateChanged($event)"
      ></lib-date-time-picker>
    </ion-item>
    <ion-item>
      <ion-label>Ende</ion-label>

      <lib-date-time-picker
        [hourDelay]="1"
        slot="end"
        [inputDateZulu]="isNewEvent ? null : this.selectedEvent.endDate"
        (selectedDateChanged)="newEventEndDateChanged($event)"
      ></lib-date-time-picker>
    </ion-item>
    <ion-item
      *ngIf="this.selectedEvent.endDate < this.selectedEvent.startDate"
      style="color: red"
    >
      Ereignis-Ende liegt vor Start
    </ion-item>
  </ion-list>

  <div class="container">
    <br />

    <ion-select
      label="Kalender"
      label-placement="floating"
      mode="md"
      fill="outline"
      [(ngModel)]="this.selectedEvent.calendarId"
      (ionChange)="evCalendarChange($event)"
    >
      <ion-select-option
        *ngFor="let ev of this.availableCalendars"
        [value]="ev.id"
        >{{ ev.name }}</ion-select-option
      >
    </ion-select>

    <br />
    <ion-textarea
      label="Beschreibung"
      labelPlacement="floating"
      fill="outline"
      mode="md"
      [(ngModel)]="this.selectedEvent.description"
      placeholder="Beschreibung hinzufügen.."
    ></ion-textarea>
    <!--lib-user-picker
            *ngIf="isNewEvent"
            [users]="this.state.users$"
            [showAllEntry]="false"
            [multiple]="true"
            (selectedUserChanged)="selectedWorkerChange($event)"
          ></lib-user-picker-->
    <br />
    <ion-button
      *ngIf="!isNewEvent"
      style="width: 100%"
      color="danger"
      (click)="deleteEvent()"
      >Ereignis löschen</ion-button
    >
  </div>
</ion-content>
